"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getReCAPTCHAToken = getReCAPTCHAToken;
var _Recaptcha = _interopRequireDefault(require("../../packages/Recaptcha"));
var _env = _interopRequireDefault(require("../../utilities/env"));
const RECAPTCHA_KEY = (0, _env.default)("REACT_APP_RECAPTCHA_KEY");
async function getReCAPTCHAToken() {
  if (!RECAPTCHA_KEY) throw new Error("reCAPTCHA key is not defined.");
  await (0, _Recaptcha.default)(RECAPTCHA_KEY);
  await new Promise(function (resolve, reject) {
    var _window$grecaptcha;
    if (!((_window$grecaptcha = window.grecaptcha) !== null && _window$grecaptcha !== void 0 && _window$grecaptcha.enterprise)) {
      reject("Google reCAPTCHA Enterprise is not defined.");
    }
    window.grecaptcha.enterprise.ready(resolve);
  });
  return window.grecaptcha.enterprise.execute(RECAPTCHA_KEY, {
    action: "submit"
  });
}